module.exports = __webpack_public_path__ + "img/facebook.1188e23f.png";